import { Box, CircularProgress } from '@mui/material'
import { FC } from 'react'

const LoadingPage: FC = () => {
  return (
    <Box
      data-testid="loading-page"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '60vh',
      }}
    >
      <CircularProgress sx={{ color: 'black' }} />
    </Box>
  )
}

export default LoadingPage
